var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56009,15.3894A2.84379,2.84379,0,0,0,5.67044,15H3.97928v6H5.33182V18.71057h.56342a2.59588,2.59588,0,0,0,1.68267-.40723,1.824,1.824,0,0,0,.63306-1.457A1.76242,1.76242,0,0,0,7.56009,15.3894ZM6.49344,17.57532a1.52118,1.52118,0,0,1-.80609.12134H5.297V16.01392h.39032a1.42354,1.42354,0,0,1,.824.15612.82583.82583,0,0,1,.347.71961A.70572.70572,0,0,1,6.49344,17.57532ZM11.07126,15H9.40647v6h1.56982a4.21125,4.21125,0,0,0,2.34955-.45056,2.81242,2.81242,0,0,0,1.14471-2.54993,2.99475,2.99475,0,0,0-.83239-2.28845A3.42221,3.42221,0,0,0,11.07126,15ZM12.389,19.639a2.41266,2.41266,0,0,1-1.36944.30285H10.759V16.05719h.26056c.84088,0,1.17.08655,1.49926.3819a2.08582,2.08582,0,0,1,.55493,1.54351A1.92589,1.92589,0,0,1,12.389,19.639ZM15.92472,15h4.07312v1.05719H17.27726v1.37042h2.72058v1.05817H17.27726V21H15.92472Zm4.07312-8v6h-2V7.82843L14.16941,4H5.99784v9h-2V2h11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPdf);
export default __webpack_public_path__ + "static/media/Document-PDF.481d7b0088b9f5430c1d7d0150343542.svg";
export { ForwardRef as ReactComponent };